import { $fetch } from '@/boot/fetch'

export default {
  getAll() {
    return $fetch.peg('/supportContacts')
  },
  getByType(supportType) {
    return $fetch.peg(`/supportContacts/${supportType}`)
  },
}
